import { NextPage } from 'next';
import { getDataFromTree } from '@apollo/client/react/ssr';
// Hoc
import withApollo from 'hocs/withApollo';
// Hooks
import { useGetFeaturedStreams } from 'hooks';
// Helpers
import { getEnvLink } from 'helpers/routes';
// Context
import { FiltersProvider } from 'components/common3/PageWithFiltersWrapper/PageWithFiltersContext';
// Types
import { StreamOrderBy, SortDirection } from 'api/graphql-global-types';
// Layouts
import { generateCollectionPageStructuredData } from 'helpers/structured-data';
import Head from 'layouts/Head/Head';
import Header from 'layouts/Header/Header';
import Main from 'layouts/Main/Main';
import Footer from 'layouts/Footer/Footer';
// Components
import StreamsContainer from 'components/Streams/Streams';
import FeaturedStreamsCarousel from 'components/HomePage/components/V3/FeaturedStreamsCarousel/FeaturedStreamsCarousel';

const STREAMS_PAGE_DESCRIPTION =
  'Watch live sports streams, PPVs, watch parties, and podcasts on MILLIONS. Discover athlete channels, local events, and fan experiences.';

const Streams: NextPage = () => {
  const image = `${getEnvLink()}${'/streams.jpg'}`;

  const { data: featuredStreamsData } = useGetFeaturedStreams();
  const featuredStreams = featuredStreamsData?.featuredPpvEvents || [];

  return (
    <>
      <Head
        image={image}
        preloadImage={featuredStreams[0]?.stream.imageURL ?? null}
        title="Live Sports Streams, PPVs, Watch Parties and Podcasts | MILLIONS"
        description={STREAMS_PAGE_DESCRIPTION}
        structuredData={generateCollectionPageStructuredData({
          name: 'Live Sports Streams, PPVs and Podcasts',
          description: STREAMS_PAGE_DESCRIPTION,
          path: '/streams',
        })}
      />

      <Header />

      <Main withHeaderOffset>
        {featuredStreams.length > 0 && (
          <FeaturedStreamsCarousel
            fullWidth
            featuredStreams={featuredStreams}
            noTopBorder
            withOrganizer
          />
        )}

        <FiltersProvider
          storesListFilter="hasActiveStreams"
          searchKey="searchTerm"
          initialSorting={{
            direction: SortDirection.ASC,
            order: StreamOrderBy.ScheduleDate,
          }}
        >
          <StreamsContainer />
        </FiltersProvider>
      </Main>

      <Footer />
    </>
  );
};

export default withApollo(Streams, { getDataFromTree });
